import HttpClientV2 from "../_tools/httpclientv2";

export async function fetchCurrencies() {
    const client = new HttpClientV2('/api/currencies');
    const res = await client.get();
    return res.data.currencies;
}
